/**
 * General APP Error.
 * @see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
 * @see https://stackoverflow.com/a/55066280/717267
 * @see https://stackoverflow.com/a/60250733/717267
 */
export class BaseError extends Error {
	// Code
	public static readonly code: number;

	/**
	 * Code getter
	 */
	public get code() {
		return (this.constructor as typeof BaseError).code;
	}

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message);
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * ApplicationError
 */
export class ApplicationError extends BaseError {
	public static override readonly code: number = 500;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Application error");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * DuplicationError
 */
export class DuplicationError extends ApplicationError {
	public static override readonly code: number = 501;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Duplication error");
		Object.setPrototypeOf(this, trueProto);
	}
}

/**
 * ConfigError
 */
export class ConfigError extends ApplicationError {
	public static override readonly code: number = 690;

	constructor(message?: string) {
		const trueProto = new.target.prototype;
		super(message ?? "Configuration error");
		Object.setPrototypeOf(this, trueProto);
	}
}
